import React from "react";
import "../styles/main.css";
import { useNavigate } from "react-router-dom";
import {
  FaArrowUp,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">

      <div className="footer-container">

        {/* LINKS */}
        <div className="footer-col">
          <h3>Links</h3>

          <ul>
            <li onClick={() => navigate("/about")}>
              About Us
            </li>

            <li onClick={() => navigate("/contact")}>
              Contact
            </li>

            <li onClick={() => navigate("/news")}>
              News
            </li>

            <li onClick={() => navigate("/gallery")}>
              Gallery
            </li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h3>Contacts</h3>

          <p>
            <FaMapMarkerAlt />
            NAV JEEVAN MISSION SCHOOL
          </p>

          <p>
            Sonauil Road, Anand Nagar, Maharajganj
          </p>

          <p>
            <FaEnvelope />
            njmsanandnagar@gmail.com
          </p>

          <p>
            <FaPhoneAlt />
            +91 7525013411, 8303360948
          </p>

        </div>

        {/* MEDIA */}
        <div className="footer-col">
          <h3>Media Links</h3>

          <div className="social-icons">

            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://youtu.be/OZDpaZ0m_vA?si=IJBafaxAdlY65TzT"
              target="_blank"
              rel="noreferrer"
            >
              <FaYoutube />
            </a>

          </div>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-disclaimer">

        <span>
          Accessibility Friendly
        </span>

        <a
          href="http://www.ilakshya.in/"
          target="_blank"
          rel="noreferrer"
          className="footer-powered-link"
        >
          Powered by iLakshya Total Solutions
        </a>


      </div>

      {/* TOP BUTTON */}
      <button
        className="scroll-top-btn"
        onClick={scrollToTop}
      >
        <FaArrowUp />
      </button>

    </footer>
  );
};

export default Footer;